export default {
  GET_MARK_SCHEMES_REQUEST: "GET_MARK_SCHEMES_REQUEST",
  GET_MARK_SCHEMES_SUCCESS: "GET_MARK_SCHEMES_SUCCESS",
  GET_MARK_SCHEMES_FAIL: "GET_MARK_SCHEMES_FAIL",

  CREATE_MARK_SCHEME_REQUEST: "CREATE_MARK_SCHEME_REQUEST",
  CREATE_MARK_SCHEME_SUCCESS: "CREATE_MARK_SCHEME_SUCCESS",
  CREATE_MARK_SCHEME_FAIL: "CREATE_MARK_SCHEME_FAIL",

  REGISTER_MARK_SCHEME_REQUEST: "REGISTER_MARK_SCHEME_REQUEST",
  REGISTER_MARK_SCHEME_SUCCESS: "REGISTER_MARK_SCHEME_SUCCESS",
  REGISTER_MARK_SCHEME_FAIL: "REGISTER_MARK_SCHEME_FAIL",

  ADD_MARK_SCHEMES_LOADING: "ADD_MARK_SCHEMES_LOADING",
};
